import { CartLinesUpdateEvent } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

 document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('[data-alpha-native-digital]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (form.dataset.adding === 'true') return;
  const button = form.querySelector('[data-alpha-digital-add]');
  const message = form.querySelector('[data-alpha-cart-error]');
  form.dataset.adding = 'true';
  button.disabled = true;
  message.hidden = true;
  let added = false;
  try {
    const data = new FormData(form);
    data.delete('return_to');
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
    if (!sectionIds.includes('cart-drawer-section') && document.getElementById('shopify-section-cart-drawer-section')) sectionIds.push('cart-drawer-section');
    data.set('sections', sectionIds.slice(0,5).join(','));
    data.set('sections_url', window.location.pathname);
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:data });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || response.statusText);
    added = true;
    const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
    if (!cartResponse.ok) throw new Error(cartResponse.statusText);
    const cart = await cartResponse.json();
    const settled = {cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail:{items:cart.items, source:'alpha-native-digital', sections:result.sections, didError:false}};
    form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(data.get('id')),quantity:Number(data.get('quantity')) || 1}],promise:Promise.resolve(settled)}));
    await sectionRenderer.renderSection('cart-drawer-section',{cache:false});
    await customElements.whenDefined('theme-drawer');
    document.getElementById('cart-drawer')?.open();
  } catch (error) {
    if (added) {
      window.location.assign(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart' : '/cart');
      return;
    }
    message.textContent = error.message;
    message.hidden = false;
  } finally {
    delete form.dataset.adding;
    button.disabled = false;
  }
 }, true);
